export enum RedirectMode {
  Self = '_self',
  Blank = '_blank'
}
